module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4wMTYiIGhlaWdodD0iMTYuMDE2IiB2aWV3Qm94PSIwIDAgMTYuMDE2IDE2LjAxNiI+CiAgPHBhdGggaWQ9Imljb19wbHVzIiBkPSJNLTIuMDE2LTMuM1YtOS4yNWgtNnYtNC4xMDloNnYtNS45NTNoNHY1Ljk1M0g4Vi05LjI1SDEuOTg0Vi0zLjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4LjAxNiAxOS4zMTMpIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ico_plus.svg
// module id = jWkV
// module chunks = 1